"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhraní pro práci s právními formami. Generated from cz.marbes.api.subjekt.v1.PravniFormaService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:56:38Z                      #

// ##############################################################

var PravniFormaApi = function () {
  function PravniFormaApi() {
    (0, _classCallCheck3.default)(this, PravniFormaApi);
  }

  (0, _createClass3.default)(PravniFormaApi, null, [{
    key: "getPravniFormaById",

    /**
     * Načtení právní formy dle id.
     *
     * @param id id právní formy
     * @return načtená právní forma
     */
    value: function getPravniFormaById(id) {
      var uri = serverContextPath + ("/api/subjekt/v1/pravniFormy/" + id);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Načtení seznamu právních forem.
     *
     * @param typPravniFormy pokud je uvedeno, vrací se právní formy jen pro daný typ, jinak se vrací pro všechny typy
     * @param pridatNeaktivni mají se přidat i neaktivní prání formy?
     * @return seznam právních forem nebo prázdný seznam
     */

  }, {
    key: "getPravniFormy",
    value: function getPravniFormy(typPravniFormy, pridatNeaktivni) {
      var uri = serverContextPath + "/api/subjekt/v1";
      var headers = undefined;
      var params = { typPravniFormy: typPravniFormy, pridatNeaktivni: pridatNeaktivni };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Dohledání právních forem dle seznamu předaných id.
     *
     * @param ids seznam id právních forem
     * @return seznam dohledaných právních forem, pokud bude předáno id neexistující právní formy, bude ignorováno
     */

  }, {
    key: "findPravniFormyByIds",
    value: function findPravniFormyByIds(ids) {
      var uri = serverContextPath + "/api/subjekt/v1/pravniFormy/byIds";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, ids, headers));
    }
  }]);
  return PravniFormaApi;
}();

exports.default = PravniFormaApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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